import { CompaniesEnum, LangEnum, MgLocalStorageKeys, SubmissionTypes } from '@enums';
import { getMgLocalStorage } from '@utils';
import { SubmissionQueryInterface } from '@types';

export type LettersPageState = {
  filters: SubmissionQueryInterface;
  isOpenSaveAsModal: boolean;
  isOpenDownloadModal: boolean;
  isOpenDeleteModal: boolean;
  isOpenMultipleDeleteModal: boolean;
  isOpenChangeTypeModal: boolean;
  isOpenReassignGroupModal: boolean;
};

const localStorageFiltersData: SubmissionQueryInterface = getMgLocalStorage(
  MgLocalStorageKeys.LETTERS_FILTERS
);

export const initialFilters: SubmissionQueryInterface = {
  groupId: '',
  limit: 100,
  submissionType: SubmissionTypes.All,
  lang: LangEnum.ALL,
  title: '',
  company: [CompaniesEnum.Itechart, CompaniesEnum.Vention],
};

export const lettersPageInitialState: LettersPageState = {
  filters: localStorageFiltersData || initialFilters,
  isOpenSaveAsModal: false,
  isOpenDownloadModal: false,
  isOpenDeleteModal: false,
  isOpenMultipleDeleteModal: false,
  isOpenChangeTypeModal: false,
  isOpenReassignGroupModal: false,
};
